﻿import {
  Chart,
  LineController,
  LineElement,
  BarController,
  BarElement,
  PointElement,
  ArcElement,
  DoughnutController,
  PieController,
  RadarController,
  BubbleController,
  ScatterController,
  PolarAreaController,
  LinearScale,
  CategoryScale,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend
} from "chart.js";

// Typen separat importieren!
import type { ChartConfiguration, ChartData,TooltipItem } from "chart.js";


// Chart.js einmalig registrieren
Chart.register(
  LineController,
  LineElement,
  BarController,
  BarElement,
  PointElement,
  ArcElement,
  DoughnutController,
  PieController,
  RadarController,
  BubbleController,
  ScatterController,
  PolarAreaController,
  LinearScale,
  CategoryScale,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
);

// Globale Chart-Defaults
//Chart.defaults.font.size = 14;
//Chart.defaults.plugins.legend.labels.color = '#000';

// Optional Chart auch global machen
//window.Chart = Chart;

// Exportieren, falls du direkt importieren willst
export { Chart,ChartConfiguration, ChartData, TooltipItem  };
